import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from '../../../../components/ToastMsg';
import { getAllLotteryBrands } from '../../../../redux/features/lotteryBrand/lotteryBrandService';
import BeatLoader from 'react-spinners/BeatLoader';
import Dropdown from '../../../../components/Dropdown/Dropdown';
import { newLotteryBrandDays } from '../../../../redux/features/lotteryBrandDay/lotteryBrandDayService';

const LotteryBrandDaysCreate = () => {
  const dispatch = useDispatch();
  const { islotteryBrandDaysCreating } = useSelector(
    (state) => state.lotteryBrandDay.lotteryBrandDays
  );
  const { lotteries } = useSelector((state) => state.lottery.allLotteryBrands);
  const dropdownRef = useRef(null);
  const [formData, setFormData] = useState({
    lotterybrandId: '',
    name: '',
    code: '',
    sampleImage: null,
  });

  const [errorMessages, setErrorMessages] = useState({
    lotterybrandId: '',
    name: '',
    code: '',
    sampleImage: '',
  });
  const [disabledBtn, setBtnDisable] = useState(false);
  const fileInputRefSample = useRef(null);

  const fetchAllLotteries = useCallback(() => {
    dispatch(getAllLotteryBrands({ status: true }));
  }, [dispatch]);

  useEffect(() => {
    fetchAllLotteries();
  }, [fetchAllLotteries]);

  const handleLotteryBrand = (option) => {
    setFormData({ ...formData, lotterybrandId: option.id });
    setErrorMessages({ ...errorMessages, lotterybrandId: '' });
  };

  const validateFile = (selectedFile, fieldName) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];

    if (!allowedTypes.includes(selectedFile.type)) {
      setErrorMessages({
        ...errorMessages,
        [fieldName]: 'Invalid file type. Allowed types: JPEG, PNG, GIF',
      });
      setFormData({ ...formData, [fieldName]: null });
      return false;
    }

    setErrorMessages({ ...errorMessages, [fieldName]: null });
    setFormData({ ...formData, [fieldName]: selectedFile });
    return true;
  };

  const handleDrop = (event, fieldName) => {
    event.preventDefault();
    event.stopPropagation();

    const selectedFile = event.dataTransfer.files[0];

    if (selectedFile) {
      validateFile(selectedFile, fieldName);
    }
  };

  const handleFileChange = (event, fieldName) => {
    if (event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      validateFile(selectedFile, fieldName);
    }
  };

  const handleClick = (ref) => {
    ref.current.click();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrorMessages((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  // Validate input
  const isValidLotteryBrand = () => {
    const errors = {};
    const trimmedName = formData.name.trim();
    const trimmedCode = formData.code.trim();

    if (!trimmedName) {
      errors.name = 'Lottery Name is required.';
    }
    if (!trimmedCode) {
      errors.code = 'Lottery Brand code is required.';
    }
    if (!formData.lotterybrandId) {
      errors.lotterybrandId = 'Lottery Brand is required.';
    }
    if (!formData.sampleImage) {
      errors.sampleImage = 'Sample Lottery Image is required.';
    }

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return false;
    } else {
      return true;
    }
  };

  const insertNewLotteryBrand = async () => {
    if (isValidLotteryBrand(formData)) {
      setBtnDisable(true);
      try {
        const response = await dispatch(newLotteryBrandDays(formData)).unwrap();
        setBtnDisable(false);
        setFormData({
          name: '',
          code: '',
          sampleImage: null,
        });
        dropdownRef.current?.clearSelection();
        fileInputRefSample.current.value = '';
        showToast('success', response.message);
      } catch (error) {
        setBtnDisable(false);
        showToast('error', error.message);
      }
    }
  };

  return (
    <div className={`card-section`}>
      <div className={`main-card`}>
        <h1 className={`form-title`}>New Lottery Brand Day</h1>
        <div className={styles.formContainer}>
          <form className={styles.coordinatorForm} noValidate>
            <div className={`form-input-row`}>
              <div className={`form-input-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='lottery-brand' className={`form-label`}>
                    Lottery Brand<span className={`required-star`}>*</span>
                  </label>
                  <Dropdown
                    ref={dropdownRef}
                    options={lotteries}
                    placeholder='Select a Brand'
                    onSelect={handleLotteryBrand}
                  />
                  {errorMessages.lotterybrandId && (
                    <p className={`text-danger`}>
                      {errorMessages.lotterybrandId}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className={`form-input-row`}>
              <div className={`form-input-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='full_name' className={`form-label`}>
                    Name<span className={`required-star`}>*</span>
                  </label>
                  <input
                    type='text'
                    id='name'
                    name='name'
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder='Enter Lottery Brand Name'
                    className={`form-input-default`}
                  />
                  {errorMessages.name && (
                    <p className={`text-danger`}>{errorMessages.name}</p>
                  )}
                </div>
              </div>
            </div>

            <div className={`form-input-row`}>
              <div className={`form-input-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='code' className={`form-label`}>
                    Code<span className={`required-star`}>*</span>
                  </label>
                  <input
                    type='text'
                    id='code'
                    name='code'
                    value={formData.code}
                    onChange={handleInputChange}
                    placeholder='Enter Lottery Brand Code'
                    className={`form-input-default`}
                  />
                  {errorMessages.code && (
                    <p className={`text-danger`}>{errorMessages.code}</p>
                  )}
                </div>
              </div>
            </div>

            <div className={`form-input-row`}>
              <div className={`form-input-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='full_name' className={`form-label`}>
                    Sample Lottery Image
                    <span className={`required-star`}>*</span>
                  </label>
                  <div
                    onDrop={(e) => handleDrop(e, 'sampleImage')}
                    onDragOver={(event) => event.preventDefault()}
                    onClick={() => handleClick(fileInputRefSample)}
                    className={styles.dropInput}
                  >
                    <input
                      type='file'
                      ref={fileInputRefSample}
                      accept='image/*'
                      onChange={(e) => handleFileChange(e, 'sampleImage')}
                      style={{ display: 'none' }}
                    />
                    {formData.sampleImage ? (
                      <div className={styles.insertedFile}>
                        <div className={styles.fileCard}>
                          <img
                            src={URL.createObjectURL(formData.sampleImage)}
                            alt='Sample'
                            className={styles.thumbnailImg}
                          />
                        </div>
                      </div>
                    ) : (
                      <p>Drag & Drop a file here or Click to select</p>
                    )}
                  </div>
                  {errorMessages.sampleImage && (
                    <p className={`text-danger`}>{errorMessages.sampleImage}</p>
                  )}
                </div>
              </div>
            </div>

            <button
              className={`btn-primary`}
              type='button'
              disabled={disabledBtn}
              onClick={insertNewLotteryBrand}
            >
              {islotteryBrandDaysCreating ? (
                <BeatLoader grade='#ffffff' />
              ) : (
                `Create`
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LotteryBrandDaysCreate;
